<template>
    <v-card>
        <v-toolbar color="primary" dark>
            <v-toolbar-title>{{label}}</v-toolbar-title>
        </v-toolbar>
        <div style="padding: 10px">
            <v-data-table style="width:100%" :headers="headers"
                          :items="items" :rows-per-page-items="rowsPerPageItems">
                <template slot="headers">
                    <th v-if="readonly==false">
                        <v-checkbox v-if="multiselect=='true'" color="primary" hide-details :readonly="readonly"
                                    v-model="selectAll" @change="onSelectAll"></v-checkbox>
                        <div v-else>
                            {{$t("lang.common.select")}}
                        </div>
                    </th>
                    <th v-for="header in headers" :width="header.width" style="text-align:left">
                        <div>
                            {{$t(header.text)}}
                        </div>
                    </th>
                </template>
                <template v-slot:items="props">
                    <td v-if="readonly==false">
                        <v-checkbox v-model="props.item['check']" color="primary" hide-details :readonly="readonly"
                                    @change="onSelectItem(props.item['check'],props.item[valueField])"
                        ></v-checkbox>
                    </td>
                    <td v-for="header in headers">
                        <div>
                            {{props.item[header.value]}}
                        </div>
                    </td>
                </template>
            </v-data-table>
        </div>
    </v-card>
</template>

<script>
    import Validator from "../../../public/js/validator";
    import FormJS from "../../../public/plugin/form/form"
    import axios from "axios";
    import VueController from "../../../public/js/controller";

    const v = Validator();

    export default {
        name: 'i-data-table',
        components: {Validator},
        inheritAttrs: true,
        props: {
            column: {
                type: String,
                default: "12"
            },
            label: {
                type: String,
                default: ""
            },
            value: {
                type: String,
                default: ""
            },
            source: {
                type: String,
                default: ""
            },
            valueField: {
                type: String,
                default: ""
            },
            variable: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            multiselect: {
                type: String,
                default: ""
            },
            readonly: {
                type: Boolean,
                default: false
            },
            rowsPerPageItems: {
                type: [Array, Number],
                default: () => [10, 20, 30, 40, 50]
            }
        },

        watch: {
            value: function (data) {
                this.loadData(this.source, this.valueField, this.value, this.multiselect);
            },
            variable: function (data) {
                this.loadData(this.source, this.valueField, this.value, this.multiselect);
            }
        },

        mounted() {
            this.loadData(this.source, this.valueField, this.value, this.multiselect);
        },

        data: () => {
            return {
                values: {},
                model: {},
                items: [],
                headers: [],
                selectedData: null,
            }
        },

        methods: {
            onApply: function () {
                this.selectedData = "";
                for (let i = 0; i < this.items.length; i++) {
                    if (this.items[i]["check"]) {
                        if (this.selectedData == "") {
                            this.selectedData = this.items[i][this.valueField];
                        } else {
                            this.selectedData = this.selectedData + "," + this.items[i][this.valueField];
                        }
                    }
                }
                this.$emit("input", this.selectedData);
            },

            loadData: function (sql, valueField, selectedData, multiselect) {
                this.show = true;
                this.selectedData = selectedData+"";
                this.valueField = valueField;
                this.multiselect = multiselect;

                /*
                                //console.log("selectedData:" + selectedData);
                                //console.log("valueField:" + valueField);
                                //console.log("multiselect:" + multiselect);
                */
                //sql = this.normalizeSQL(sql);
                sql = encodeURI(FormJS.normalizeSQL(sql,this.variable));
                axios.post(process.env.VUE_APP_API_URL + "/workflow/getdata?sql=" + sql).then(data => {
                        if (data.length > 0) {
                            let ob = data[0];
                            let fields = [];
                            for (let key in ob) {
                                let field = {text: key, value: key, order: false};
                                fields.push(field);
                            }
                            this.headers = fields;
                            if (this.selectedData != undefined && this.selectedData != null && this.selectedData != "") {
                                let arr = this.selectedData.split(",");
                                for (let i = 0; i < data.length; i++) {
                                    for (let j = 0; j < arr.length; j++) {
                                        if (data[i][valueField] == arr[j]) {
                                            data[i]["check"] = true;
                                            break;
                                        }
                                    }
                                }
                            }
                            this.items = data;
                            ////console.log("--- data items ---");
                            ////console.log(this.items);
                        }
                    },
                    error => {

                    }
                );
            },

            onSelectItem: function (check, value) {
                //console.log(check + "-" + value);
                if (check == true) {
                    //console.log("check==true");
                    //console.log(this.multiselect);

                    if (this.multiselect == undefined || this.multiselect == null || this.multiselect == "false" || this.multiselect == "") {
                        //console.log("here");
                        for (let i = 0; i < this.items.length; i++) {
                            if (this.items[i]["check"] == true && this.items[i][this.valueField] != value) {
                                this.items[i]["check"] = false;
                            } else {
//                                //console.log(this.items[i][this.valueField]);
                            }
                        }
                    }
                } else {
                    if (this.selectAll == true) {
                        this.selectAll = false;
                    }
                }
                this.onApply();
            },

            onSelectAll: function () {
                for (let i = 0; i < this.items.length; i++) {
                    this.items[i]["check"] = this.selectAll;
                }
            }

        }
    }
</script>
